const filterToggle = {
  filterBtn: null as HTMLElement | null,
  filterWrap: null as HTMLElement | null,
  overlay: null as HTMLElement | null,
  close: null as HTMLElement | null,
  initialized: false,

  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init(), {
        once: true,
      });
      return;
    }

    if (this.initialized) return;

    this.filterBtn = document.getElementById("jsBtnFilter");
    this.filterWrap = document.getElementById("left-sidebar");
    this.overlay = document.getElementById("overlay");
    this.close = document.getElementById("jsCloseFilter");

    // Skip pages without the filter elements
    if (!this.filterBtn || !this.filterWrap || !this.overlay || !this.close) {
      return;
    }

    this.initialized = true;

    this.openFilter();
    this.closeFilter();
    this.closeOverlay();
  },

  setFilterState(isOpen: boolean) {
    if (!this.filterBtn || !this.filterWrap || !this.overlay) {
      return;
    }

    this.filterBtn.dataset.filter = String(isOpen);

    this.filterWrap.classList.toggle("activeClass", isOpen);
    this.overlay.classList.toggle("activeClass", isOpen);
    document.body.classList.toggle("activeClass", isOpen);

    document.documentElement.style.overflow = isOpen ? "hidden" : "auto";
  },

  openFilter() {
    this.filterBtn?.addEventListener("click", () => {
      const isOpen = this.filterBtn?.dataset.filter === "true";

      this.setFilterState(!isOpen);
    });
  },

  closeFilter() {
    this.close?.addEventListener("click", () => {
      this.setFilterState(false);
    });
  },

  closeOverlay() {
    this.overlay?.addEventListener("click", () => {
      this.setFilterState(false);
    });
  },
};

export default filterToggle;
